import { SxProps } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useContext } from 'react';
import { TimelineContext } from '@/common/components/timeline/TimelineContext.ts';

export interface TimelineLineProps {
  sx?: SxProps;
}

export const TimelineLine = ({ sx }: TimelineLineProps) => {
  const { lineColor } = useContext(TimelineContext);

  return <Box width={2} flex={1} minHeight={10} sx={{ backgroundColor: lineColor, ...sx }} />;
};
